<div class="d-flex justify-content-center align-items-center" style="height: 100vh;">
  <div class="text-center">
    <h1 class="display-1">404</h1>
    <h2 class="display-4">Página não encontrada</h2>
    <p>MATRÍCULA NÃO ENCONTRADA: Contacte o responsável pelo link</p>
</div>

